import aes from 'crypto-js/aes';
import utf8 from 'crypto-js/enc-utf8';

function doDecrypt(data) {
  const bytes = aes.decrypt(data, process.env.VUE_APP_AUTH_COOKIE_SECRET);
  return JSON.parse(bytes.toString(utf8));
}

export default doDecrypt;
